// extracted by mini-css-extract-plugin
module.exports = {"buttonpane":"TimerSelectBtns_buttonpane__AXbeZ"};